"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
/**
 * What type of event is represented
 *   dal - a data access layer event (update/insert/delete of observable)
 *   log - a log record originating from something
 *   audit - an auditable event occured
 */
exports.EventType = {
    dal: 'dal',
    data: 'data',
    log: 'log',
    //audit: 'audit'
};
//# sourceMappingURL=eventType.js.map